"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ZPopup = void 0;
const React = __importStar(require("react"));
const AppContext_1 = require("../../utils/AppContext");
const kendo_react_buttons_1 = require("@progress/kendo-react-buttons");
const CorrelationGroups_1 = require("../../apis/CorrelationGroups");
const utils_1 = require("../../utils");
const kendo_react_dialogs_1 = require("@progress/kendo-react-dialogs");
const useLocalizedProps_1 = require("../../languages/useLocalizedProps");
const useViewport_1 = require("../../utils/useViewport");
const react_dom_1 = __importDefault(require("react-dom"));
const styled_components_1 = __importDefault(require("styled-components"));
const EmptyComponent = () => {
    return React.createElement("div", null);
};
const MaximizeButtonComponent = (props) => {
    return React.createElement(kendo_react_buttons_1.Button, Object.assign({ icon: "window-maximize", look: "clear" }, props));
};
const RestoreButtonComponent = (props) => {
    return React.createElement(kendo_react_buttons_1.Button, Object.assign({ icon: "window-restore", look: "clear" }, props));
};
const defaultWidth = 800;
const ZPopupComponent = (props) => {
    const { className, modal, allowMaximize, onMaximizeChange, ...windowProps } = useLocalizedProps_1.useLocalizedProps(props);
    const { isMobile } = React.useContext(AppContext_1.AppContext);
    const { innerHeight, innerWidth } = useViewport_1.useViewport();
    const [maximized, setMaximized] = React.useState(false);
    const frameContext = React.useContext(utils_1.FrameContext);
    const MaximizeButton = () => {
        return (React.createElement(MaximizeButtonComponent, { onClick: () => {
                setMaximized(true);
                onMaximizeChange && onMaximizeChange(true);
            } }));
    };
    const RestoreButton = () => {
        return (React.createElement(RestoreButtonComponent, { onClick: () => {
                setMaximized(false);
                onMaximizeChange && onMaximizeChange(false);
            } }));
    };
    return react_dom_1.default.createPortal(React.createElement("div", { className: [className, "z-popup"].join(" ").trim() },
        React.createElement(CorrelationGroups_1.CorrelationGroup, null,
            React.createElement(kendo_react_dialogs_1.Window, Object.assign({}, windowProps, { modal: modal === false ? false : true, resizable: props.resizable || false, stage: isMobile || maximized ? "FULLSCREEN" : "DEFAULT", ref: window => {
                    if (props.popupRef && typeof props.popupRef === "function") {
                        props.popupRef(window);
                    }
                }, height: props.resizable
                    ? undefined
                    : isMobile || maximized
                        ? innerHeight
                        : windowProps.height, width: props.resizable
                    ? undefined
                    : isMobile || maximized
                        ? innerWidth
                        : windowProps.width, initialHeight: props.resizable
                    ? isMobile || maximized
                        ? innerHeight
                        : windowProps.initialHeight
                    : undefined, initialWidth: props.resizable
                    ? isMobile || maximized
                        ? innerWidth
                        : windowProps.initialWidth
                    : undefined, initialLeft: props.resizable
                    ? isMobile || maximized
                        ? 0
                        : (innerWidth -
                            (windowProps.initialWidth || defaultWidth)) /
                            2
                    : undefined, minimizeButton: EmptyComponent, restoreButton: isMobile || !allowMaximize ? EmptyComponent : RestoreButton, maximizeButton: allowMaximize && !maximized && !isMobile
                    ? MaximizeButton
                    : EmptyComponent }), props.children))), frameContext.document.body);
};
exports.ZPopup = AppContext_1.withAppContext(styled_components_1.default(ZPopupComponent) `
      & .k-button.k-button:not(.k-button-icon) {
         box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2),
            0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12) !important;
         transition-duration: 0s !important;
         &.k-primary:not(.k-state-disabled) {
            background: ${props => props.theme["app-link-color"]} !important;
            color: ${props => props.theme["action-button-hover-text-color"]};
            &:hover {
               background: ${props => props.theme["hover-color"]}!important;
               color: ${props => props.theme["action-button-hover-text-color"]};
            }
            &:active {
               background: ${props => props.theme["active-color"]}!important;
               color: ${props => props.theme["action-button-hover-text-color"]};
            }
         }
         &:hover {
            background: ${props => props.theme["hover-color"]}!important;
            color: ${props => props.theme["action-button-hover-text-color"]};
         }
         &:active {
            background: ${props => props.theme["active-color"]}!important;
            color: ${props => props.theme["action-button-hover-text-color"]};
         }
      }
      & .k-button-icon {
         & .k-icon.k-icon.k-icon {
            color: ${props => props.theme["popup-border-color"]};
         }
         &:hover .k-icon.k-icon.k-icon {
            color: ${props => props.theme["hover-color"]};
         }
         &:active .k-icon.k-icon.k-icon {
            color: ${props => props.theme["active-color"]};
         }
      }
      .k-window {
         background: ${props => props.theme["popup-content-background-color"]};
         display: ${props => (!props.visible ? "none" : "")};
         height: ${props => props.appContext &&
    props.appContext.isMobile === false &&
    props.height === undefined &&
    !props.resizable
    ? "unset !important"
    : null};

         & :not(.k-icon) {
            font-family: ${props => props.theme["font-family"]} !important;
         }
      }
      .k-window-titlebar .k-button:nth-last-of-type(3) {
         display: none;
         // hide minimize button
      }
      .k-window-titlebar.k-header {
         padding: 10px 10px 10px 24px;
         font-size: 20px;
         font-family: ${props => props.theme["font-family"]};
      }
      height: ${props => props.appContext &&
    props.appContext.isMobile === false &&
    props.height === undefined
    ? props.resizable === false
        ? "fit-content"
        : null
    : null};
   `);
//# sourceMappingURL=ZPopup.js.map